import type { PropsWithChildren } from "react";
import { useCallback, useState } from "react";
import { useNotificationContext } from "@entrilia/shared/contexts/NotificationContext";
import biApi from "../../../../../../api/biApi";
import type { ReportTemplate } from "../../../../../../api/types/svTypes.ts";
import DeleteTemplateDialog from "../../templates/DeleteTemplateDialog.tsx";
import { useReportTemplatesContext } from "../ReportTemplatesContext.ts";
import { ReportTemplateUiManagerContextProvider } from "./ReportTemplatesUiManagerContext";

interface Props {
  onDeleted?: () => void;
}
export default function ReportTemplatesUiManager({ children, onDeleted }: PropsWithChildren<Props>) {
  const { sendNotification } = useNotificationContext();
  const { reportTemplates } = useReportTemplatesContext();

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [templatesToDelete, setTemplatesToDelete] = useState<ReportTemplate[]>([]);

  const deleteTemplates = useCallback(
    (ids: string[]) => {
      const toDelete = reportTemplates.filter((r) => ids.includes(r.reportId));
      setTemplatesToDelete(toDelete);
      setOpenDeleteDialog(true);
    },
    [reportTemplates]
  );

  return (
    <ReportTemplateUiManagerContextProvider deleteTemplates={deleteTemplates}>
      {children}
      {openDeleteDialog && templatesToDelete.length > 0 && (
        <DeleteTemplateDialog
          templates={templatesToDelete}
          doDelete={(templates) =>
            biApi.deleteReportTemplates({
              templates: templates.map((t) => ({ templateId: t.reportId, organization: t.organization })),
            })
          }
          onDeleted={() => {
            sendNotification("The report was successfully deleted.");
            onDeleted?.();
          }}
          onClose={() => {
            setOpenDeleteDialog(false);
            setTemplatesToDelete([]);
          }}
        />
      )}
    </ReportTemplateUiManagerContextProvider>
  );
}
